"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _thirdSamList = _interopRequireDefault(require("./thirdSamList.vue"));
var _thirdSamAdd = _interopRequireDefault(require("./thirdSamAdd.vue"));
var _orderList = _interopRequireDefault(require("./orderList.vue"));
var _couponList = _interopRequireDefault(require("./couponList.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '外部对接',
  components: {
    thirdSamList: _thirdSamList.default,
    thirdSamAdd: _thirdSamAdd.default,
    orderList: _orderList.default,
    couponList: _couponList.default
  },
  data: function data() {
    return {
      refresh: false,
      actTitle: null,
      actId: null,
      loading: false,
      activeTab: 'thirdSamList',
      tabs: ['thirdSamList', 'orderList', 'couponList']
    };
  },
  computed: {
    maxHeight: function maxHeight() {
      return "".concat(window.innerHeight - 497, "px");
    }
  },
  methods: {
    saved: function saved() {
      this.refresh = true;
      this.activeTab = 'thirdSamList';
    },
    addAct: function addAct() {
      this.activeTab = 'thirdSamAdd';
      this.actId = null; // 新增时清空
    },
    handleCoupon: function handleCoupon(row) {
      this.activeTab = 'couponList';
      // this.actTitle = row.activityName;
      this.actId = row.id;
    },
    handleEdit: function handleEdit(row) {
      this.activeTab = 'thirdSamAdd';
      this.actId = row.id;
    },
    handleCopy: function handleCopy(row) {
      this.activeTab = 'thirdSamAdd';
      this.actId = row.id + '_copy';
    },
    detailUser: function detailUser(row) {
      this.activeTab = 'orderList';
      // this.actTitle = row.activityName;
      this.actId = row.id;
    },
    handleTabChange: function handleTabChange(tab) {
      this.activeTab = tab.name;
      this.actId = null;
    },
    removeTab: function removeTab(tabName) {
      // const index = this.tabs.indexOf(tabName)
      // if (index !== -1) this.tabs.splice(index, 1)
      // if (this.activeTab === tabName) {
      //     this.activeTab = 'taskList'
      // }
    }
  },
  mounted: function mounted() {}
};